<div class="mx-2 d-lg-none">
  <py-catalog-sort
    *ngIf="showSort"
    class="w-100 mt-2"
    [searchResults$]="searchResults$"
    [activeTabIndex$]="activeTabIndex$"
  ></py-catalog-sort>
  <button
    class="w-100 btn btn-ternary mt-2 d-flex justify-content-center align-items-center"
    (click)="openDrawer()"
    *ngIf="{ customFilterCount: customFilterCount$ | async } as data"
  >
    {{ 'catalog.filter_tab' | cxTranslate }}
    <i *ngIf="data.customFilterCount === 0" nz-icon nzType="filter" outline class="ml-2"></i>
    <py-badge [tag]="true" class="ml-2" *ngIf="data.customFilterCount > 0">{{ data.customFilterCount }}</py-badge>
  </button>
</div>

<div class="d-none d-lg-flex flex-column">
  <ng-container *ngIf="addonGroup" [ngTemplateOutlet]="addonTemplate"></ng-container>
  <ng-container
    *ngIf="!addonGroup"
    [ngTemplateOutlet]="categoriesTemplate"
    [ngTemplateOutletContext]="{ displayedInDrawer: false }"
  ></ng-container>
</div>

<ng-template #drawerTemplate>
  <py-drawer-template [title]="'catalog.filter_tab' | cxTranslate" [body]="drawerBody"> </py-drawer-template>

  <ng-template #drawerBody>
    <div class="pt-2 px-4">
      <ng-container *ngIf="addonGroup" [ngTemplateOutlet]="addonTemplate"></ng-container>
      <ng-container
        *ngIf="!addonGroup"
        [ngTemplateOutlet]="categoriesTemplate"
        [ngTemplateOutletContext]="{ displayedInDrawer: true }"
      ></ng-container>
    </div>
  </ng-template>
</ng-template>

<ng-template #addonTemplate>
  <div class="py-7" [class.border-bottom]="!addonNode ? addonGroup.children?.length + addonGroup.nodes?.length > 0 : false">
    <h2 class="h5">
      {{ 'addon.articleCollections_filter' | cxTranslate }} ({{
        !addonNode ? addonGroup.children?.length + addonGroup.nodes?.length : 0
      }})
    </h2>
    <ul *ngIf="!addonNode" class="pt-5">
      <li *ngFor="let child of addonGroup.children">
        <cx-generic-link
          [routerUrl]="{ cxRoute: 'addon', params: { title: addonGroup.title } } | cxUrl"
          [queryParams]="{ ag: child.id }"
        >
          <div class="category-link h6 d-flex justify-content-between">
            {{ child.title }}
            <i nz-icon nzType="arrow-right" outline></i>
          </div>
        </cx-generic-link>
      </li>
      <li *ngFor="let node of addonGroup.nodes">
        <cx-generic-link
          [routerUrl]="{ cxRoute: 'addon', params: { title: addonGroup.title } } | cxUrl"
          [queryParams]="{ ag: addonGroup.id, an: node.id }"
        >
          <div class="category-link h6 d-flex justify-content-between">
            {{ node.title }}
            <i nz-icon nzType="arrow-right" outline></i>
          </div>
        </cx-generic-link>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #categoriesTemplate let-displayedInDrawer="displayedInDrawer">
  <div class="border-bottom py-7">
    <h2 class="h5">
      <ng-container *ngIf="hasAreaOfUse; else standardCategories">
        {{ 'catalog.areaOfUse_filter' | cxTranslate }}
      </ng-container>
      <ng-template #standardCategories>
        {{ 'catalog.categories_filter' | cxTranslate }}
      </ng-template>
      ({{ categories?.length }})
    </h2>

    <ul *ngIf="categories?.length > 0" class="pt-5">
      <li *ngFor="let category of getCategories">
        <cx-generic-link [url]="categoryUrl(category)">
          <div class="category-link h6 d-flex justify-content-between">
            {{ category.name }}
            <i nz-icon nzType="arrow-right" outline></i>
          </div>
        </cx-generic-link>
      </li>
    </ul>
    <div *ngIf="categories?.length > 12 && !showAllCategories" class="d-flex justify-content-start">
      <a class="load-more-link pt-4 pb-0" (click)="showAllCategories = !showAllCategories">
        {{ 'common.showMore_action' | cxTranslate }}
      </a>
    </div>
  </div>

  <!-- Custom Filters Section -->
  <div class="py-7 border-bottom custom-filters-section">
    <!-- My Assortment Filter -->
    <ng-container *ngIf="hasCustomerAssortment$ | async">
      <div *ngIf="{ checked: myAssortment$ | async } as data" class="facet-item py-2">
        <py-checkbox [showLabel]="true">
          <input
            type="checkbox"
            [id]="'' | randomId"
            [checked]="data.checked"
            (change)="updateQueryStringParameter({ mya: data.checked ? '0' : '1' })"
          />
          <span slot="label" class="d-flex w-100 h6 filter-label-wrapper">
            <i nz-icon nzType="contracted-article" class="d-flex align-self-center mr-2"></i>
            {{ 'catalog.customerAssortment_filter' | cxTranslate }}
          </span>
        </py-checkbox>
      </div>
    </ng-container>

    <!-- Tendered Articles Filter -->
    <ng-container *ngIf="hasTendered$ | async">
      <div *ngIf="{ checked: tenderedArticles$ | async } as data" class="facet-item py-2">
        <py-checkbox [showLabel]="true">
          <input
            type="checkbox"
            [id]="'' | randomId"
            [checked]="data.checked"
            (change)="updateQueryStringParameter({ t: data.checked ? null : '1' })"
          />
          <span slot="label" class="d-flex w-100 h6 filter-label-wrapper">
            <i nz-icon nzType="like" nzTheme="outline" class="d-flex align-self-center mr-2"></i>
            {{ 'catalog.tenderedArticles_filter' | cxTranslate }}
          </span>
        </py-checkbox>
      </div>
    </ng-container>

    <!-- Outlet Filter -->
    <ng-container *pyPrincipalConfiguration="'enableDisplayOutgoingArea'">
      <ng-container *ngIf="{ activeSoldTo: activeSoldTo$ | async } as data">
        <ng-container *ngIf="data.activeSoldTo?.outgoingAssortmentAllowed || !data.activeSoldTo">
          <div *ngIf="{ checked: outlet$ | async } as data" class="facet-item py-2">
            <py-checkbox [showLabel]="true">
              <input
                type="checkbox"
                [id]="'' | randomId"
                [checked]="data.checked"
                (change)="updateQueryStringParameter({ o: data.checked ? null : '1' })"
              />
              <span slot="label" class="d-flex w-100 h6 filter-label-wrapper">
                <i nz-icon nzType="percentage" nzTheme="outline" class="d-flex align-self-center mr-2"></i>
                {{ 'catalog.outlet_filter' | cxTranslate }}
              </span>
            </py-checkbox>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- Last Chance Filter -->
    <ng-container *pyPrincipalConfiguration="'displaybadgeforZTarticle'">
      <div *ngIf="{ checked: lastChance$ | async } as data" class="facet-item py-2">
        <py-checkbox [showLabel]="true">
          <input
            type="checkbox"
            [id]="'' | randomId"
            [checked]="data.checked"
            (change)="updateQueryStringParameter({ zt: data.checked ? null : '1' })"
          />
          <span slot="label" class="d-flex w-100 h6 filter-label-wrapper">
            <i nz-icon nzType="calendar" nzTheme="outline" class="d-flex align-self-center mr-2"></i>
            {{ 'catalog.lastChance_filter' | cxTranslate }}
          </span>
        </py-checkbox>
      </div>
    </ng-container>
  </div>

  <ng-container *ngFor="let facet of facets$ | async">
    <py-catalog-filter-facet
      *ngIf="(!hasAreaOfUse && facet.code !== 'categoryCode') || (hasAreaOfUse && facet.code !== 'articleAreasOfUse')"
      [initialCollapsed]="initialCollapsed(facet)"
      [initialShowAll]="initialShowAll(facet)"
      [facet]="facet"
      [displayedInDrawer]="displayedInDrawer"
      (handleFilter)="handleChange($event)"
      (handleShowAll)="handleShowAll($event, facet)"
    ></py-catalog-filter-facet>
  </ng-container>

  <div *ngIf="displayedInDrawer" class="d-flex align-items-center py-7 mb-7 reset-facets-wrapper" (click)="resetFacets()">
    <i nz-icon pyIconThemeReverse class="d-flex mr-2" nzType="close-circle" nzTheme="outline"></i>
    <span>{{ 'catalog.resetFilters_action' | cxTranslate }}</span>
  </div>
</ng-template>
